// extracted by mini-css-extract-plugin
export default {"cls1":"GrantsMarketingButton-cls1_sZk","cls2":"GrantsMarketingButton-cls2_fC9 GrantsMarketingButton-cls1_sZk"};